module.exports = __webpack_public_path__ + "img/et.e1f1999e.svg";